import React from 'react';
import { LoginContainer } from './login.style';
import { useNavigate } from 'react-router-dom';
import ReactLogo from '../../asserts/RaptorNet_color.svg';
import { ReactSVG } from 'react-svg';
import { GoogleLogin } from '@react-oauth/google';
import './login.scss';
import jwt_decode from 'jwt-decode';
import axios from 'axios';
import keys from '../../constants.js';
import { useAuth } from '../../App'; // adjust path if needed

// Helpers
function normalizeRoles(roleFromApi) {
  if (!roleFromApi) return [];
  if (Array.isArray(roleFromApi)) return roleFromApi;
  const s = String(roleFromApi).trim();
  if (!s) return [];
  if (s.toLowerCase() === 'all') return ['All']; // treat as superuser in your guards
  // support comma-separated e.g. 'Admin,HR'
  return s.split(',').map(function(r){ return r.trim(); }).filter(Boolean);
}

function buildUser(googleClaims, apiData) {
  // googleClaims is the decoded id_token
  // apiData: { role, section, status, ... }
  const roles = normalizeRoles(apiData && apiData.role);
  return {
    id: googleClaims.sub,
    name: googleClaims.name,
    email: googleClaims.email,
    email_verified: googleClaims.email_verified,
    picture: googleClaims.picture,
    // app-specific
    roles: roles,
    role: apiData ? apiData.role : undefined,       // keep raw role too
    section: apiData ? apiData.section : undefined, // as sent by your API
    login_ts: Date.now()
  };
}

const Login = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  const responseMessage = async function(response) {
    try {
      if (!response || !response.credential) {
        alert('Invalid Google response');
        return;
      }

      // 1) Decode Google JWT
      var claims = jwt_decode(response.credential);
      if (!claims || !claims.email) {
        alert('Google account did not return an email');
        return;
      }

      // 2) Special-case account (your original behavior)
      if (claims.email === 'securityscreening@aischennai.org') {
        var specialUser = buildUser(claims, { role: 'all', section: 'all', status: true });
        localStorage.setItem('userData', JSON.stringify(specialUser));
        localStorage.setItem('userRole', JSON.stringify('all'));
        localStorage.setItem('userSection', JSON.stringify('all'));
        setUser(specialUser);
        navigate('/dashboard', { replace: true });
        return;
      }

      // 3) Call your API to resolve role/section
      var url = keys.APIPATH + '/authUser.php';
      var reqBody = { email: claims.email };

      var apiRes = await axios.post(url, reqBody, {
        headers: { 'Content-Type': 'application/json' }
      });

      if (!apiRes || !apiRes.data) {
        alert('Auth server did not respond');
        return;
      }

      if (apiRes.data.status) {
        // 4) Merge and persist
        var mergedUser = buildUser(claims, apiRes.data);
        localStorage.setItem('userData', JSON.stringify(mergedUser));
        // keep legacy keys for existing code paths
        localStorage.setItem('userRole', JSON.stringify(apiRes.data.role));
        localStorage.setItem('userSection', JSON.stringify(apiRes.data.section));
        setUser(mergedUser);
        navigate('/dashboard', { replace: true });
      } else {
        alert('Access denied. Please contact admin.');
      }
    } catch (err) {
      console.error(err);
      alert('Login failed. Try again.');
    }
  };

  const errorMessage = function() {
    alert('Please check username/password');
  };

  return (
    <LoginContainer>
      <div className='login-container'>
        <div
          style={{
            textAlign: 'center',
            padding: '10px',
            width: '300px',
            position: 'relative',
            top: '-160px'
          }}
        >
          <ReactSVG src={ReactLogo} className='logo-svg' />
          <div style={{ paddingTop: '22px' }} className='google-login'>
            <GoogleLogin onSuccess={responseMessage} onError={errorMessage} />
          </div>
        </div>
      </div>
    </LoginContainer>
  );
};

export default Login;
